import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from 'ngx-spinner';
import { CreativeService } from "src/app/core/services/creative.service";
import { nativeAdTypes, videoIframe } from 'src/app/models/creatives';
import { SignContractService } from 'src/app/core/services/contract.service';
import { AppConfig } from 'src/app/configs/app.config';
import { crtvNativeTypes } from 'src/app/models/bdsp/bdsp-creative';
import { tdspNativeTypes } from 'src/app/models/tdsp/creatives';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})

export class PreviewComponent implements OnInit {

  @ViewChild('tag_iframe') iframe: ElementRef;

  previewDetails;
  landingPage;
  thirdPartyTag;
  adType
  msa_contract_id = {};
  preview;
  iconPreview;
  setIframe: boolean = false;
  height;
  width;
  termsAndConditionsAccepted:boolean = false;
  isPlaying: boolean = true;
  adsp: boolean = false;
  bdsp: boolean = false;
  tdsp: boolean = false;

  nativeOfferDetails;
  nativeAttributes;

  nativeAdtypes: Array<any> = nativeAdTypes;
  bdspNativeVdeoUrl: string;
  bdspNativesWithImg = new Set(['native_video_content_inline', 'native_image_content', 'native_video_content_vast_vpaid_wrapper'])
  nativeVideoPreviewUrl:string;
  nativeVideoTagPreview: boolean = false;
  readonly imgPath: string;
  readonly nativeTypes;
  readonly tdspNativeTypes;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private creativeService: CreativeService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private signContractService: SignContractService,
    public dialogRef: MatDialogRef<PreviewComponent>
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
    this.nativeTypes = crtvNativeTypes;
    this.tdspNativeTypes = tdspNativeTypes;
   }

  ngOnInit(): void {
    this.previewDetails = this.data.details;
    this.landingPage = this.data.landingPage
    this.thirdPartyTag = this.data.thirdPartyTag
    this.adType = this.data.adType;
    this.height = this.data.height;
    this.width = this.data.width;
    this.adsp = this.data.adsp;
    this.bdsp = this.data.bdsp;
    this.tdsp = this.data.tdsp;
    this.nativeOfferDetails = this.data.nativeOfferDetails;
    if (this.tdsp && tdspNativeTypes.has(this.adType)) {
          this.nativeAttributes = this.data.nativeAttributes;
      if (this.nativeAttributes.image_asset?.s3_file_url) {
        this.isPlaying = false;
      }
    }
    if(this.data.isBulkUpload) {
      this.nativeVideoTagPreview = this.data.nativeVideoThirdParty;
    } else {
      if (
        this.adType == "native_video" && !this.tdsp &&
        this.previewDetails.native_attributes.video_creative_ids[0].details
          .third_party_tag
      ) {
        this.nativeVideoTagPreview = true;
      }
    }
    if (this.data.isBulkUpload && this.tdsp) {
      this.preview = this.data.details;
    } else {
      this.createPreview();
    }
  }

  playVideo() {
    this.isPlaying = true
  }

  assignId(event) {
    this.msa_contract_id['msa_contract_id'] = event.checked? this.data.msa_id : null;
  }

  acceptContract() {
    let params = {};
    params[this.data.clientTypeId] = this.data.clientId
    this.signContractService.create(this.msa_contract_id, params).subscribe((res)=>{

    }, ()=>{}, () =>{
      this.closeModel(true);
    })
  }

  closeModel(save = false) {
    this.dialogRef.close({
      save: save,
    });
  }

  showTagPreview() {
    this.spinner.show();
    setTimeout(() => {
      let iframeDoc = this.iframe.nativeElement.contentWindow.document;
      let iframeData = this.previewDetails.third_party_tag;
      iframeDoc.open();
      if (
        this.adType == "video" ||
        this.adType == "connected_tv" ||
        this.nativeVideoTagPreview
      ) {
        iframeData = this.nativeVideoTagPreview
          ? videoIframe.replace(
              "{video_tag}",
              this.data.isBulkUpload
                ? this.data.videoPreviewUrl
                : this.previewDetails.native_attributes.video_creative_ids[0]
                    .details.third_party_tag
            )
          : videoIframe.replace(
              "{video_tag}",
              this.previewDetails.third_party_tag
            );
      }
      iframeDoc.write(iframeData);
      iframeDoc.close();
      this.spinner.hide();
    }, 2000);
  }

  createPreview() {
    if(this.data.type == 'creative-preview') {
      if(!this.adsp && !this.bdsp && !this.tdsp) {
        if (this.adType == 'html5') {
          this.preview = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewDetails.preview_url);
        } else if (!this.previewDetails.third_party_tag) {
          if (nativeAdTypes.includes(this.adType)) {
            if (this.adType == "native_video") {
              if(this.nativeVideoTagPreview) {
                this.showTagPreview();
              } else {
                this.nativeVideoPreviewUrl = this.data.isBulkUpload ? this.data.videoPreviewUrl
                  :this.previewDetails.native_attributes.video_creative_ids[0].details.preview_url;
              }
            }
            this.preview = this.previewDetails.native_attributes.image_url;
            this.iconPreview = this.previewDetails.native_attributes.icon_url;
          } else {
            this.preview = this.previewDetails.preview_url;
          }
        } else {
          this.setIframe = true;
          if (this.adType == 'audio') {
            this.creativeService.getDetails(this.previewDetails.third_party_tag).subscribe(res => {
              let parser = new DOMParser();
              let xmlDoc = parser.parseFromString(res, "text/xml");
              let mediaFiles = xmlDoc.getElementsByTagName('MediaFile');
              for (let i = 0; i < mediaFiles.length; i++) {
                let content = mediaFiles[i].innerHTML.match(/((https|http)?:\/\/[^ ]*(mp3|ogg))/)
                if (content && content.length > 0) {
                  this.preview = content[0];
                  break;
                }
              }
            })
          } else {
            this.showTagPreview();
          }
        }
        if(this.data.is_coupon_crtv){
          this.preview = encodeURI(this.previewDetails.preview_url)
        }
      }
      if (this.adsp || this.bdsp || this.tdsp) {
        if(this.previewDetails && this.previewDetails.s3_file_url) {
          this.preview = this.previewDetails.s3_file_url;
          if (this.adType == 'native_video_content_inline') {
            this.preview = this.previewDetails.secondary_asset?.s3_file_url;
            this.bdspNativeVdeoUrl = this.previewDetails.s3_file_url
          }
          if(this.adType == 'html5') {
            this.preview = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewDetails.s3_file_url);
          }
        } else if (this.landingPage || this.thirdPartyTag) {
          this.setIframe = true;
          this.spinner.show();
          if (this.adType == 'native_video_content_vast_vpaid_wrapper') {
              this.preview = this.previewDetails.secondary_asset?.s3_file_url
          }
          setTimeout(() => {
            let iframeDoc = this.iframe.nativeElement.contentWindow.document;
            let iframeData = this.landingPage
              ? this.landingPage.third_party_tag
              : this.tdsp ? this.thirdPartyTag : this.thirdPartyTag.content_tag;
            iframeDoc.open();
            if(this.adType == 'video' || this.adType == 'native_video_content_vast_vpaid_wrapper') {
              iframeData = videoIframe.replace('{video_tag}', this.adsp
                ? this.landingPage.third_party_tag.toString()
                : this.tdsp ? this.thirdPartyTag : this.thirdPartyTag.content_tag.toString());
            }
            iframeDoc.write(iframeData);
            iframeDoc.close();
            this.spinner.hide();
          }, 2000);
        } else {
          this.setIframe = true;
          if (this.adType == 'audio') {
            this.creativeService.getDetails(this.tdsp ? this.thirdPartyTag : this.thirdPartyTag.content_tag).subscribe(res => {
              let parser = new DOMParser();
              let xmlDoc = parser.parseFromString(res, "text/xml");
              let mediaFiles = xmlDoc.getElementsByTagName('MediaFile');
              for (let i = 0; i < mediaFiles.length; i++) {
                let content = mediaFiles[i].innerHTML.match(/((https|http)?:\/\/[^ ]*(mp3|ogg))/)
                if (content && content.length > 0) {
                  this.preview = content[0];
                  break;
                }
              }
            })
          }
        }
      }
    }
  }
}
